import { CartLineEdgeNode } from 'shopify-buy';
import React from 'preact/compat';

interface Props {
  line: CartLineEdgeNode;
  type?: 'regular' | 'compareAt';
}

export const toCents = (dollars: number): number => dollars * 100;

const applyDiscounts = (line: CartLineEdgeNode): number => {
  let discounted = 0;
  if (
    !!line.sellingPlanAllocation &&
    line.sellingPlanAllocation.priceAdjustments.length > 0
  ) {
    discounted =
      line.sellingPlanAllocation.priceAdjustments[0].price.amount *
      line.quantity;
  } else {
    discounted =
      line.__typename === 'ComponentizableCartLine'
        ? line.cost.totalAmount.amount || 0
        : (line.merchandise?.price.amount || 0) * line.quantity;
  }

  line.discountAllocations.forEach((discount) => {
    if (discount.discountedAmount && discount.discountedAmount.amount) {
      discounted = discounted - discount.discountedAmount.amount;
      return;
    }
  });

  return discounted;
};

export const LineItemPrice: React.FC<Props> = ({ line, type = 'regular' }) => {
  let variantPrice = undefined;
  const compareAtPrice = line.merchandise?.compareAtPrice?.amount;

  if (
    !!line.sellingPlanAllocation &&
    line.sellingPlanAllocation.priceAdjustments.length > 0
  ) {
    variantPrice = line.sellingPlanAllocation.priceAdjustments[0].price.amount;
  } else {
    variantPrice = line.merchandise?.price?.amount;
  }

  if (!variantPrice) {
    return null;
  }

  const discountedPrice = applyDiscounts(line);
  const discountedCents = toCents(discountedPrice);

  const format =
    discountedPrice - Math.floor(discountedPrice) === 0
      ? (window?.theme?.moneyFormat || '${{ amount_no_decimals }}').replace(
          /<[^>]+>/g,
          ''
        )
      : window.Shopify.money_format;

  return (
    <>
      {type === 'regular' ? (
        <>
          <span className={'sr-only'}>Current Price: </span>
          <span>{window.Shopify.formatMoney(discountedCents, format)}</span>
        </>
      ) : null}

      {type === 'compareAt' &&
      compareAtPrice &&
      toCents(compareAtPrice * line.quantity) > discountedCents ? (
        <>
          <span className={'sr-only'}>Regular Price: </span>
          <span style={{ textDecoration: 'line-through', marginRight: '8px' }}>
            {window.Shopify.formatMoney(
              toCents(compareAtPrice * line.quantity),
              format
            )}
          </span>
        </>
      ) : null}
    </>
  );
};
